import { cloneJson, deepFreeze } from './json'

const RAW_KEY = '$raw'

export function attachRaw<T extends object>(entity: T, raw: unknown): T {
  Object.defineProperty(entity, RAW_KEY, {
    value: deepFreeze(cloneJson(raw)),
    enumerable: false,
    writable: false,
    configurable: true,
  })
  return entity
}

export function hasRaw(entity: object): boolean {
  return Object.prototype.hasOwnProperty.call(entity, RAW_KEY)
}

export function getRaw(entity: object): unknown {
  const descriptor = Object.getOwnPropertyDescriptor(entity, RAW_KEY)
  if (!descriptor) {
    throw new Error('Entity has no $raw')
  }

  return descriptor.value
}
